const EnabledSegmentIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width={14} height={14} fill='none'>
    <g clipPath='url(#a)'>
      <path
        fill='#402080'
        d='M5.044 1.954 3.417 3.582a.289.289 0 0 0 .204.496h1.044v3.505c0 .321.262.584.583.584.321 0 .584-.263.584-.584V4.078h1.044c.262 0 .39-.315.204-.496L5.452 1.954a.292.292 0 0 0-.408 0Zm4.288 7.969V6.417a.585.585 0 0 0-.584-.584.585.585 0 0 0-.583.584v3.506H7.12a.289.289 0 0 0-.204.495l1.627 1.622a.3.3 0 0 0 .414 0l1.628-1.622c.186-.18.052-.495-.204-.495h-1.05Z'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='#fff' d='M0 0h14v14H0z' />
      </clipPath>
    </defs>
  </svg>
)
export default EnabledSegmentIcon
